import * as React from 'react';

const I18nContext = React.createContext({
  lang: 'da',
  locale: {}
});

export default I18nContext;